<template>
    <div class="container" v-cloak>
        <div class="row justify-content-center">
            <div class="col-xl-10">
                <filter-bar></filter-bar>
                <div :class="{ 'loader--loading' : $store.state.loading }" class="loader">
                    <svg xmlns="http://www.w3.org/2000/svg" style="margin:auto;background:none;display:block;shape-rendering:auto" width="60px" height="60px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="matrix(.8 0 0 .8 10 2)"><polygon fill="#f37362" points="72.5 50 50 11 27.5 50 50 50"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.5384615384615383s" values="0 50 38.5;360 50 38.5" keyTimes="0;1"/></polygon><polygon fill="#47bbe3" points="5 89 50 89 27.5 50"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.5384615384615383s" values="0 27.5 77.5;360 27.5 77.5" keyTimes="0;1"/></polygon><polygon fill="#90c987" points="72.5 50 50 89 95 89"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.5384615384615383s" values="0 72.5 77.5;360 72 77.5" keyTimes="0;1"/></polygon></g></svg>
                </div>
                <div class="row post-cards" :class="classObject, { 'post-cards--loading' : $store.state.loading }">
                    <download-card v-if="postType === 'download'" v-for="post in posts.items" v-bind:post="post"></download-card>
                    <post-card-event v-else-if="postType === 'event'" v-for="post in posts.items" v-bind:post="post"></post-card-event>
                    <post-card-case v-else-if="postType === 'ervaring'" v-for="post in posts.items" v-bind:post="post"></post-card-case>
                    <post-card-inspiratie v-else-if="postType === 'inspiratie'" v-for="post in posts.items" v-bind:post="post"></post-card-inspiratie>
                    <post-card-aanbod v-else-if="postType === 'aanbod'" v-for="post in posts.items" v-bind:post="post"></post-card-aanbod>
                    <post-card v-else v-for="post in posts.items" v-bind:post="post"></post-card>
                </div>
                <pagination v-model="posts.pagination.page" :records="posts.headers.totalItems" :per-page="posts.perPage" @paginate="paginate()" :options="posts.pagination.options"/>
            </div>
        </div>
        <seo-text></seo-text>
    </div>
    <div class="posts__filter" id="filter">
        <filter-wrapper></filter-wrapper>
    </div>
</template>
<script>

    import Filter from './Filter';
    import FilterBar from './FilterBar';
    import PostCard from "./PostCard";
    import PostCardEvent from "./PostCardEvent";
    import PostCardCase from "./PostCardCase";
    import PostCardInspiratie from "./PostCardInspiratie";
    import PostCardAanbod from "./PostCardAanbod";
    import DownloadCard from "./DownloadCard";
    import Pagination from 'v-pagination-3';
    import axios from "axios";
    import MyPagination from './Pagination';
    import {mapGetters} from "vuex";
    import DynamicUrl from './DynamicUrl';
    import FiltersFromAddressBar from "./FiltersFromAddressBar";
    import GetSeoText from "./GetSeoText";

    export default {

        data() {
            return {
                posts: {
                    headers: {
                        totalItems: 1,
                        totalPages: Number,
                    },
                    items: [],
                    loader: 'loader.svg',
                    perPage: this.$store.state.postPerPage,
                    excludedCategory: {},
                    pagination: {
                        page: this.$store.state.page,
                        options: {
                            edgeNavigation: true,
                            theme: 'bootstrap4',
                            chunk: 10,
                            chunksNavigation: 'fixed',
                            template: MyPagination,
                            texts: {
                                nextChunk: '>>',
                                prevChunk: '<<'
                            }
                        }
                    },
                },
                postType: '',
                postCategories: '',
                shownCategory: '',
                baseUrl: '',
                loadingState: false
            }
        },
        mixins: [DynamicUrl, FiltersFromAddressBar, GetSeoText],
        computed: {
            ...mapGetters({
                filterTrigger: 'filterTrigger',
            }),

            classObject() {
                return {
                    'post-cards--horizontal' : this.postType === 'event',
                    'post-cards--download' : this.postType === 'download'
                }
            },
            resetFiltersAll() {
                return this.$store.state.resetAllFilters;
            },
            initialFilterLoad() {
                // When all filters are loaded from dom-element (at this state no filter checkbox is set yet)
                return this.$store.state.filtersInitialLoad;
            },
            allFiltersSetFromUrl() {
                return this.$store.state.allFiltersSetFromUrl;
            }
        },
        watch: {
            filterTrigger() {
                // console.log('load from filterTrigger');
                this.resetPagination();
                this.$store.state.loading = true;
                this.getPosts();
                this.$store.state.resetAllFilters = false;
                this.createDynamicAddressbarUrl();
                this.GetSeoText();
            },
            resetFiltersAll(value) {
                // Load all posts when we have resetted filters
                this.resetPagination();
                this.getPosts(value);
                this.$store.state.loading = true;
            },
            initialFilterLoad(value) {
                if (value == true) {
                    // We can now set the filters from the URL sections because we have waited for all filterblocks to be loaded from the dom-element.
                    this.setFiltersFromAddressbarUrl();
                }
            },
            allFiltersSetFromUrl() {
                // Load posts after we've setted filters from URL sections
                // Set page number from store
                this.posts.pagination.page = this.$store.state.page;
                this.$store.state.loading = true;
                this.$store.state.filterState = true;
                console.log('getPosts + GetSeoText after filters set from page load');
                this.getPosts();
                // this.GetSeoText();
            }
        },
        components: {
            Pagination,
            'post-card': PostCard,
            'post-card-event': PostCardEvent,
            'post-card-case': PostCardCase,
            'post-card-inspiratie': PostCardInspiratie,
            'post-card-aanbod': PostCardAanbod,
            'download-card': DownloadCard,
            'filter-wrapper': Filter,
            'filter-bar': FilterBar,
            'seo-text': GetSeoText
        },
        methods: {
            getPosts(isReset = false) {
                let _this = this;

                _this.postType = _this.$store.state.postType;
                _this.shownCategory = this.$store.state.shownCategory;
                // Fetch posts
                if (_this.loadingState === false) {
                    _this.loadingState = true;
                    let pagePosts = function pagePosts() {
                        let fetchUrl = _this.fetchUrl(isReset);

                        return axios.get(fetchUrl)
                            .then(response => {
                                // Set 'headers' meta data

                                _this.posts.headers.totalItems = parseInt(response.headers['x-wp-total']);
                                _this.posts.headers.totalPages = parseInt(response.headers['x-wp-totalpages']);

                                // Set total items
                                _this.fillTotalItems(_this.posts.headers.totalItems);

                                // Set posts to local data
                                _this.posts.items = response.data;

                                if (_this.$store.state.initialPageLoad === true) {
                                    // _this.setCanonicals(_this.posts.pagination.page, _this.posts.headers.totalPages);
                                }

                                _this.$store.state.initialPageLoad = false;

                                console.info('%c getPosts() => '+ fetchUrl , 'color: #bada55');
                                // console.log('dubblecheck');
                                _this.GetSeoText();
                            })
                            .catch(e => {
                                //_this.errors.push(e);
                            });
                    };

                    let axiosQueue = [pagePosts()];
                    if (axiosQueue) {
                        return Promise.all(axiosQueue)
                            .then(function (v) {
                                // Disable loading
                                _this.$store.state.loading = false;
                                _this.loadingState = false;
                            })
                    }
                }
            },
            fillTotalItems(count) {
                document.getElementById('filter-bar-total').innerHTML = count;
            },
            paginate() {
                this.$store.state.loading = true;
                this.$store.state.page = this.posts.pagination.page;
                this.createDynamicAddressbarUrl();
                this.getPosts();
            },
            resetPagination() {
                this.$store.state.page = 1;
                this.posts.pagination.page = 1;
            },
            fetchUrl(isReset) {
                let perPage = this.posts.perPage;
                let postType = this.postType;
                let shownCategory = this.shownCategory;

                let filterParamsString = '';
                let Filters = this.$store.state.Filters

                Filters.forEach((filterItem, index) => {
                    if (filterItem.values.length > 0) {
                        let paramName = filterItem.tax;
                        let paramValues = [];
                        filterItem.values.forEach((filterValue, index) => {
                            paramValues.push(filterValue.id);
                        });
                        let paramValuesString = paramValues.join(',');

                        filterParamsString += '&' + paramName + '=' + paramValuesString;
                    }
                });

                let pageNumber = this.$store.state.page.toString();

                let fetchUrl = window.location.origin;
                fetchUrl += '/wp-json/wp/v2/';
                fetchUrl += postType;
                fetchUrl += '?per_page=' + perPage;
                fetchUrl += '&page=' + pageNumber;

                if (shownCategory) {
                    fetchUrl += '&aanbod_type=' + shownCategory;
                }

                // Exclude category from to fetch data (setted by ACF on overviewpage)
                if (this.posts.excludedCategory) {
                    let exclTaxObj = this.posts.excludedCategory;

                    // Only add to URL when same category is not called by specific page load. (So it should be set as Filter already because then we do want to show this specific category)
                    let addExcludeParam = true;
                    Filters.forEach((filterItem, index) => {
                        if (filterItem.values.length > 0) {
                            let paramName = filterItem.tax;
                            if (paramName === exclTaxObj.taxonomy) {
                                addExcludeParam = false;
                            }
                        }
                    });

                    if (addExcludeParam === true) {
                        fetchUrl += '&' + exclTaxObj.taxonomy + '_exclude[]=' + exclTaxObj.term_id;
                    }
                }
                // Taxonomy exclude example
                // fetchUrl += '&locatie_exclude[]=65';

                if(!isReset) {
                    fetchUrl += filterParamsString;
                }

                return fetchUrl;
            },
            getExcludedCategory() {
                // Get hidden filters (categories) from DOM so the categories can be excluded from fetching
                const excludedCategory = document.getElementById('posts').getAttribute('data-excluded-category');
                const excludedCategoryParsed = JSON.parse(excludedCategory);

                this.posts.excludedCategory = excludedCategoryParsed;
            },

            setBaseUrl() {
                this.baseUrl = window.location.origin;
            }
        },

        created() {
            this.getExcludedCategory();
            this.setBaseUrl();

            let pathName = window.location.pathname;
            pathName = pathName.replace('/inspiraties/', '');
            pathName = pathName.slice(0, -1); // remove trailing slash

            if (!pathName) {
                this.getPosts();
            }
        }
    }
</script>
